import { useNavigate, Link } from 'react-router-dom';
import { useState, useEffect, useRef } from 'react';

import useFetchSites from '../hooks/useFetchSites';

import ListSite from '../components/ListSite';

import { formatCurrency } from '../utils/Format';

const SiteList = () => {
    const navigate = useNavigate();
    const { sites, fetchSites, loading, error } = useFetchSites();

    const didFetchRef = useRef(false);

    useEffect(() => {
        if (didFetchRef.current) return;
        didFetchRef.current = true;
        fetchSites();
    }, [fetchSites]);

    const handleRowDoubleClick = (event) => {
        const clickedRowData = event.rowData;
        const uuid = clickedRowData.UUID_;
        if (uuid) navigate(`/sites/${uuid}`);
    };

    // console.log(sites);

    return (
        <div class="flex-1 p-6 lg:p-10">
            <div class="gap-6 grid grid-cols-12">
                <div class="gap-6 grid grid-cols-12 col-span-12 xxl:col-span-9">
                    <div class="col-span-12">
                        <div class="flex items-center bg-gray-900 drop-shadow-xl mb-6 px-8 rounded-lg w-full min-h-20">
                            <div id="url" class="flex gap-x-2 font-semibold text-gray-400 text-sm sm:text-lg">
                                <Link to="/sites" class="hover:text-white decoration-orange-600 hover:underline hover:underline-offset-2 transition hover:translate-y-[-2px] duration-300">Sites</Link>
                                <span class="cursor-default">/</span>
                            </div>
                        </div>
                        <ListSite lstSites={sites} handleRowDoubleClick={handleRowDoubleClick} loading={loading} />
                    </div>
                </div>
            </div>
        </div>


    );
};

export default SiteList;

